import { View } from '@gin-betting/core';

function isDefault(market: View.Market) {
    return !market.specifiers.some(s => {
        return s.name === 'total' || s.name === 'hcp';
    });
}

function isHCP({ specifiers }: View.Market) {
    return (
        specifiers.some(s => s.name === 'hcp') &&
        !specifiers.some(s => s.name === 'total')
    );
}

function isTotal(market: View.Market) {
    return market.specifiers.some(s => {
        return s.name === 'total';
    });
}

export default { isDefault, isHCP, isTotal };
